export default __webpack_public_path__ + "static/media/sql.c4c1fe8b.png";